import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GamingService } from '@app/services/gaming.service';
import { commonComponents } from '@app/shared/common components/common components';
import { CandidateDetails } from '../Interface';


@Component({
  standalone: false,
  selector: 'app-edit-exclusion',
  templateUrl: './edit-exclusion.component.html',
  styleUrls: ['./edit-exclusion.component.css']
})
export class EditExclusionComponent {
  @Output() updateParent = new EventEmitter<any>();
  @Input() editFields: CandidateDetails;
  @Output() closePopup=new EventEmitter<void>();
  @Output() response1 = new EventEmitter<any>();
 
  editField=commonComponents.exclusion.editfields
  isLoading=false;
  errorMessage: string;
  exclusionList: any;
  isEditing=true
  originalFields: any = {};
  popup = true;
  successMessage: string;
  tosterMessage = {
    message: '',
    type: ''
  }
  constructor(private gamingService: GamingService)  { }
  
  ngOnInit(){
    const formattedDob = this.formateDate(this.editFields.dob);
    this.editFields.dob = formattedDob;
    this.originalFields = this.editFields
  }
  formateDate(dateString:any){
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
  saveCandidate() {
    this.isLoading = true;
    this.gamingService.updateExclusionList(this.editFields)
      .subscribe({
        next: (response) => {
          console.log('Response:', response);
          this.tosterMessage = {
            message: 'The candidate has been updated successfully.',
            type: 'success'
          };
          this.isLoading = false;
          this.updateParent.emit(this.editFields);
          console.log('Gaming Exclusion List updated successfully', response);
          setTimeout(() => {
            this.isLoading = false;
            this.response1.emit('success');
          }, 1000);
        },
        error: (err) => {
          console.error('Error updating record:', err);
          this.isLoading = false;
          this.tosterMessage = {
            message: 'Update failed',
            type: 'failed'
          };
          this.response1.emit('failure');
          this.errorMessage = `Error: ${err.message}`;
         
        }
      });
  }
  onUpdate() {
    console.log('Saving the updated candidate:', this.editFields);
    this.saveCandidate();
    this.popup = false; 
  }

  onCancel() {
    console.log('Cancelling the form changes');
    this.closePopup.emit();  
  }

}